import React from "react";
import { Alert, Button, Form, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default function InactiveTerminalsSection({
  darkMode = false,
  cargas,
  errores,
  inactivos,
  rows = [],
  total = 0,
  searchValue,
  onSearchChange,
  filtros,
  onFiltrosChange,
  provinciaOptions = [],
  onRefresh,
  collapsedSet,
  onToggleCollapse,
  onViewClient,
  onManage,
  currency,
}) {
  return (
    <section className={`crm-postventa-panel crm-alert-surface ${darkMode ? "is-dark" : ""}`}>
      <div className="crm-alert-section-header">
        <div>
          <h3>Terminales inactivas</h3>
          <span className="crm-postventa-card-label">Mostrando {rows.length} de {total}</span>
        </div>
        <Button className="crm-postventa-filter-button" variant="outline-success" onClick={onRefresh}>
          <FontAwesomeIcon className="me-2" icon={faArrowsRotate} />
          Actualizar
        </Button>
      </div>

      <div className="crm-alert-support-copy">
        Terminales activas que llevan más de 90 días sin operar para control comercial, recupero o retiro.
      </div>

      <div className="crm-alert-filter-grid crm-alert-filter-grid-inactivos">
        <Form.Control
          type="search"
          className="crm-postventa-filter-control"
          placeholder="Buscar por comercio, CUIT, terminal, provincia o responsable..."
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          aria-label="Buscar terminales inactivas"
        />
        <Form.Select
          className="crm-postventa-filter-control"
          value={filtros.provincia}
          onChange={(event) => onFiltrosChange("provincia", event.target.value)}
          aria-label="Filtrar terminales inactivas por provincia"
        >
          <option value="">Todas las provincias</option>
          {provinciaOptions.map((item) => (
            <option key={`inactivo-provincia-${item}`} value={item}>{item}</option>
          ))}
        </Form.Select>
        <Form.Select
          className="crm-postventa-filter-control"
          value={filtros.diasSinOperar}
          onChange={(event) => onFiltrosChange("diasSinOperar", event.target.value)}
          aria-label="Filtrar terminales inactivas por rango"
        >
          <option value="">Todos los rangos</option>
          <option value="90-120">90-120</option>
          <option value="121-180">121-180</option>
          <option value="181-365">181-365</option>
          <option value="Mas de 365">Más de 365</option>
        </Form.Select>
      </div>

      {cargas ? (
        <div className="crm-postventa-subtle py-3"><Spinner animation="border" size="sm" className="me-2" />Cargando terminales inactivas...</div>
      ) : errores ? (
        <Alert variant="danger" className="mb-0">{errores}</Alert>
      ) : (
        <div className="crm-alert-inactive-list">
          {rows.length ? rows.map((item, index) => {
            const cardId = `${item.cuit}-${item.terminal}-${index}`;
            const collapsed = collapsedSet.has(cardId);

            return (
              <article className={`crm-alert-inactive-card ${darkMode ? "is-dark" : ""}`} key={cardId}>
                <div
                  role="button"
                  tabIndex={0}
                  className="crm-alert-inactive-head"
                  onClick={() => onToggleCollapse(cardId)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onToggleCollapse(cardId);
                    }
                  }}
                >
                  <div className="crm-alert-inactive-title">
                    <strong>{item.comercio || "-"}</strong>
                    <span>CUIT {item.cuit || "-"} · Terminal {item.terminal || "-"}</span>
                  </div>
                  <div className="crm-alert-inactive-summary">
                    <span>{item.diasSinOperar || 0} días sin operar</span>
                    <span>Últ. gestión {item.ultimaGestion || "-"}</span>
                  </div>
                  <div className="crm-alert-inline-actions" onClick={(event) => event.stopPropagation()}>
                    <Button size="sm" variant="outline-secondary" onClick={() => onViewClient(item)}>Ver cliente</Button>
                    <Button size="sm" variant="success" onClick={() => onManage(item)}>Gestionar</Button>
                  </div>
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className="crm-alert-accordion-chevron"
                    style={{ transform: collapsed ? "none" : "rotate(180deg)" }}
                  />
                </div>

                {!collapsed ? (
                  <div className="crm-alert-inactive-grid">
                    <div className="crm-alert-inactive-column">
                      <h4>Datos del comercio</h4>
                      <div>CUIT: {item.cuit || "-"}</div>
                      <div>Terminal: {item.terminal || "-"}</div>
                      <div>Razón social: {item.razonSocial || "-"}</div>
                      <div>Provincia: {item.provincia || "-"}</div>
                      <div>Teléfono: {item.telefono || "-"}</div>
                    </div>
                    <div className="crm-alert-inactive-column">
                      <h4>Actividad</h4>
                      <div>Última facturación: {item.ultimaFechaFacturacion || "-"}</div>
                      <div>Días sin operar: {item.diasSinOperar || 0}</div>
                      <div>Facturación 30 días: {currency(item.facturacionUltimos30Dias)}</div>
                      <div>Promedio histórico: {currency(item.facturacionPromedioHistorica)}</div>
                    </div>
                    <div className="crm-alert-inactive-column">
                      <h4>Seguimiento</h4>
                      <div>Responsable: {item.usuarioResponsable || "-"}</div>
                      <div>Próximo contacto: {item.proximoContacto || "-"}</div>
                      <div>Acción sugerida: {item.accionSugerida || "-"}</div>
                    </div>
                  </div>
                ) : null}
              </article>
            );
          }) : (
            <Alert variant="secondary" className="mb-0">
              {inactivos?.message || "No hay terminales inactivas que coincidan con los filtros actuales."}
            </Alert>
          )}
        </div>
      )}
    </section>
  );
}
